import React, { useState, useEffect, useRef } from 'react';
import { SdmTypography } from 'components';
import IconButton from '@material-ui/core/IconButton';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';

import { theme } from '../theme';

export const SdmImageUploader = ({ onUploaded, value, disabled }) => {
  const [upImg, setUpImg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);

  const inputFileRef = useRef(null);

  useEffect(() => {
    if (value) setUpImg(value);
  }, [value]);

  const onSelectFile = async (file) => {
    const reader = new FileReader();

    reader.addEventListener('loadend', () => {
      const fileData = { info: file, data: reader.result };

      if (fileData) {
        onUploaded && onUploaded(fileData);
        setUpImg(fileData.data);
      }
    });

    reader.addEventListener('error', () => {
      setErrorMsg('Error uploading file');
    });
    reader.readAsDataURL(file);
  };

  const onBtnClick = () => {
    if (errorMsg) {
      setUpImg(null);
      setErrorMsg(null);
    }
    inputFileRef?.current?.click();
  };

  const renderError = () => {
    if (errorMsg) {
      return (
        <SdmTypography
          variant={'h3'}
          textAlign={'center'}
          style={{ color: theme.colors.primary.red }}
        >
          {errorMsg}
        </SdmTypography>
      );
    }
    return null;
  };

  return (
    <div>
      <div style={{ position: 'relative' }}>
        {!disabled ? (
          <>
            <IconButton
              style={{
                margin: '4px !important',
                borderRadius: '4px !important',
                backgroundColor: theme.colors.primary.red,
                position: 'absolute',
                top: '3px',
                right: '3px',
                zIndex: 100,
              }}
              onClick={() => onBtnClick()}
            >
              <PhotoCameraOutlinedIcon
                style={{ color: theme.colors.primary.white }}
              />
            </IconButton>
            <input
              type="file"
              accept="image/*"
              ref={inputFileRef}
              onChange={(e) => {
                if (e.target.files && e.target.files.length > 0) {
                  onSelectFile(e.target.files[0]);
                }
              }}
              style={{ display: 'none' }}
            />
          </>
        ) : null}
        <div
          style={{
            margin: '50px 0',
            maxHeight: 350,
            overflowY: 'hidden',
          }}
        >
          {renderError()}
          {upImg && !errorMsg ? (
            <img
              src={upImg}
              onError={() => setErrorMsg('Error reading file')}
              style={{
                width: '100%',
                height: 350,
                objectFit: 'contain',
                objectPosition: 'center',
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
